import { observer } from 'mobx-react-lite'
import { useLocation } from 'react-router-dom'
import PrimaryNavRail from './PrimaryNavRail'
import useMediaQueryMatch from '../hooks/useMediaQueryMatch'

export const PRIMARY_SIDEBAR_WIDTH = 80

export default observer(function PrimarySidebarNav () {
  const location = useLocation()
  const desktop = useMediaQueryMatch('(min-width: 769px)')

  const hiddenRoutes = ['/login', '/register', '/forgot-password', '/reset-password']
  if (hiddenRoutes.some((route) => location.pathname.startsWith(route))) {
    return null
  }

  if (!desktop) {
    return null
  }

  return <PrimaryNavRail variant="sidebar" showLabels />
})
